/*
 * logs/sagas
 *
 * Actions may be watched, but sagas should only ever call actionCreators,
 * and should not dispatch actions directly.
 */

import { takeLatest } from "redux-saga/effects";

import api from "../../api";
import { fetchPagedSagaFactory } from "../policies/sagas/utils";
import { auditLogEntities,auditLogs } from "./actions";
import {
  FETCH_AUDIT_LOG_ENTITIES_START,
  FETCH_AUDIT_LOGS_START} from "./constants";

export const auditLogsSaga = fetchPagedSagaFactory(
  api.AuditLogs.get,
  auditLogs.success,
  auditLogs.failed
);

export const auditLogEntitiesSaga = fetchPagedSagaFactory(
  api.AuditLogEntities.get,
  auditLogEntities.success,
  auditLogEntities.failed
);

export function* watchAuditLogs() {
  yield takeLatest(FETCH_AUDIT_LOGS_START, auditLogsSaga);
}

export function* watchAuditLogEntities() {
  yield takeLatest(FETCH_AUDIT_LOG_ENTITIES_START, auditLogEntitiesSaga);
}
